// extracted by mini-css-extract-plugin
export default {"goal_action_modal":"styles_goal_action_modal__+V5As"};